export default class QaiChallengeFilterViewModel {
    public flagThisWeek: boolean = true;
    public flagLastWeek: boolean = false;
    public flagThisMonth: boolean = false;
    public flagLastMonth: boolean = false
    public flagClient: boolean = true;
    public flagTemplate: boolean = false;
    public flagSection: boolean = false;
    public flagStatus: boolean = false;
    public flagStates: boolean = false;
    public client: string = '';
    public template: string = '';
    public section: string = '';
    public status: string = '';
    public states: string[] = [];
    public pageNumber: number = 0;
    public maxPageNumber: number | null = null

    constructor(view?: string) {
        if (view === "QA") {
            this.flagStatus = true;
            this.status = 'Escalated';
            this.flagStates = true;
            this.states = ['New', 'Upheld'];
        }
    }
}